import { Pipe, PipeTransform } from '@angular/core';
import { Pages } from '@shared/components/pagination/model';

@Pipe({
  name: 'getLabel',
  standalone: true,
})
export class GetLabelPipe implements PipeTransform {
  transform(page: Pages): string | number {
    if (page.type === 'page' && typeof page.label === 'number' && page.label < 10) {
      return `0${page.label}`;
    }
    return page.label;
  }
}
